import LetterBoxContainer from "../../../../Component/Application/Email/LetterBox/LetterBox"

const LetterBox = () => {
  return (
    <div className='page-body'>
      <LetterBoxContainer />
    </div>
  )
}

export default LetterBox